import { IContactDetails } from '../../../Contact/components/OptOutModal/interfaces';
import { NoteTypeEnum } from '../../components/CommunicationModal/types';

export interface AssignedUser {
  id: string;
  email: string;
  name: string;
}

export interface InitialLeadScoreParameters {
  state: string;
  ficoScore: number;
  age: number;
  assetYear: number;
  lienAmount: number;
  lienRate: number;
  lienPayment: number;
  monthlyIncome: number;
  sourceName: string;
}

export interface Score {
  initialLeadScore: number;
  initialLeadScoreParameters: InitialLeadScoreParameters;
}

export interface CreatedBy {
  id: string;
  email: string;
  name: string;
}

export interface UpdatedBy {
  id: string;
  email: string;
  name: string;
}

export interface ILead {
  id: string;
  numericId: number;
  contactId: string;
  assetNumericId: number;
  primarySourceName: string;
  secondarySourceName: string;
  primarySourceId: string;
  secondarySourceId: string | null;
  assignedUser: AssignedUser;
  assetId: string;
  assetTag: string;
  assetLienAmount: number;
  noOfNotes: number;
  lastNoteDateTime: string;
  currentWorkFlowStepName: string;
  currentWorkFlowStepDate: string;
  lastActivity: string;
  lastActivityDate: string;
  loanApplicationId: string | null;
  marketingInfo: string | null;
  score: Score | null;
  createdBy: CreatedBy;
  updatedBy: UpdatedBy;
  createdDate: string;
  updatedDate: string;
  showDealCalculatorButton: boolean;
  showOverrideDealButton: boolean;
  creditScore: number | null;
  pickedDealId: string;
  channelType?: number;
  createWithNumericId?: boolean;
  oneToOneConsentPresentedAndAccepted: string;
}

export interface ILeadNote {
  id: string;
  leadId: string;
  leadNoteTypes: NoteTypeEnum[];
  note: string;
  createdBy: INoteCreator;
  createdDate: string;
}

export interface IDialerData {
  id: string;
  date: string;
  type: string;
  result: string;
  duration: string;
  numberDialed: string;
  agent: string;
}

export interface INoteCreator {
  id: string;
  email: string;
  name: string;
}

export interface ILeadsCommunicationProps {
  lead: ILead;
  mutateLeads: () => void;
  contactDetails: IContactDetails;
}

export interface FieldLabelProps {
  label: string;
  value: string;
}

export interface ILeadSource {
  id: string;
  name: string;
  description: string;
  isSecondary: boolean;
  allowSecondary: boolean;
}

export type InitialStateLeadFormType = {
  id: string;
  numericId: number;
  assetId: string;
  assetTag: string;
  assignedUser?: AssignedUser;
  primarySourceId: string;
  primarySourceName: string;
  secondarySourceId: string;
  secondarySourceName: string;
  currentWorkFlowStepDate: string;
  currentWorkFlowStepName: string;
  lastActivity: string;
  lastNoteDateTime: string;
  lastActivityDate: string;
  noOfNotes: number;
  oneToOneConsentPresentedAndAccepted: string;
};

export interface ILeadModalProps {
  modalIsOpen: number;
  isLoading: boolean;
  handleSubmit: (data: ILead) => Promise<void>;
  currentLead: ILead | null;
  handleClose: () => void;
  secondarySources: ILeadSource[];
  defaultPrimarySource: ILeadSource;
}

export interface INotesRequestAddBody {
  contactId: string;
  leadId: string;
  leadNoteTypes: NoteTypeEnum[];
  note: string;
}

export enum SOURCES {
  PHONE_APPEND = 'PHONE_APPEND',
}
